export enum UserType {
  Unknown = 0,
  Ofqual = 1,
  CCEA = 2,
  AO = 3,
}

export type User = {
  upn: string;
  displayName: string;
  token: string;
  roles: number[];
  userType: UserType;
  org: {
    id: number;
    name: string;
  };
}

// if there is any state from other modules that we use in this module
//  we have an opportunity to at least type it for ourselves.
// If nothing else, store.auth will be needed to get to get the api token
interface RemoteState {
  auth: {
    user: User;
  };
}

export interface GlobalState extends RemoteState {
  // nothing here at the moment
}
